import { Action } from '../../responsePanelItem/types';

export interface ActionCategory {
  actionCategoryName: string;
  actions: Array<Action>;
  category: CategoryType;
}

export interface ActionNeededData extends Array<ActionCategory> {}

export interface ExecutedData extends Array<Action> {}

export interface ResponseData {
  actionNeeded: ActionNeededData;
  executed: ExecutedData;
  lastUpdated: string;
}

export enum ActionType {
  UNDEFINED = 0,
  ISOLATE_HOST = 1,
  DELETE_EMAIL_O365 = 2,
  DISABLE_USER_O365 = 3,
  DISABLE_USER_AD = 4,
  ENABLE_USER_O365 = 5,
  ENABLE_USER_AD = 6,
  RESET_CREDENTIALS_O365 = 7,
  RESET_CREDENTIALS_AD = 8,
  MANAGE_UNMANAGED = 9,
  BLOCK_FILE_HASH = 10,
  SYSTEM_REPAIR = 11,
  BLOCK_IP = 12,
  RESTORE_ENDPOINT = 13,
  RISKY_USER = 14,
  DEACTIVATE_USER_AWS = 15,
}

export enum CategoryType {
  CONTAINMENT = 1,
  MITIGATION = 2,
  REMEDIATION = 3,
  HARDENING = 4,
}
